import styled from 'styled-components'
import { useIsMobile } from '../../hooks/useMediaQuery'

const MultiColumnFormColumnContainerStyled = styled.div<{
  $isMobile?: boolean
}>`
  display: flex;
  flex-direction: column;
  width: 50%;

  ${({ $isMobile }) =>
    $isMobile &&
    `
      width: 100%;
    `}
`

interface MultiColumnFormColumnContainerProps {
  children: React.ReactNode
}

const MultiColumnFormColumnContainer = ({
  children,
}: MultiColumnFormColumnContainerProps) => {
  const isMobile = useIsMobile()
  return (
    <MultiColumnFormColumnContainerStyled $isMobile={isMobile}>
      {children}
    </MultiColumnFormColumnContainerStyled>
  )
}

export default MultiColumnFormColumnContainer
